import { useState, type FormEvent } from 'react';
import api, { ApiError } from '../lib/apiClient';
import { downloadFile } from '../utils/download';

// TS port of the source (Falah) app's pages/reports/ReceiptsReport.jsx.
// Bank-reconciliation CSV export of recorded receipts for a date range —
// GET /reports/receipts (ReportController::receiptsCsv(), verified still
// present in routes/api.php with the same `from`/`to` params).
function toDateInputValue(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function firstOfMonth(): string {
  const d = new Date();
  return toDateInputValue(new Date(d.getFullYear(), d.getMonth(), 1));
}

function today(): string {
  return toDateInputValue(new Date());
}

export function ReceiptsReport() {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(today());
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  const download = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setDownloading(true);
    try {
      await downloadFile(api, '/reports/receipts', `receipts-${from}-to-${to}.csv`, { from, to });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Download failed.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <header className="page-header">
        <h1>Receipts</h1>
      </header>
      <p className="muted">Export recorded receipts as a bank statement-style CSV for a date range.</p>

      <div className="card">
        <form onSubmit={download} className="form-grid">
          {error && <div className="alert alert-error span-2">{error}</div>}
          <label>
            From *
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} required />
          </label>
          <label>
            To *
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} required />
          </label>
          <div className="form-actions span-2">
            <button className="btn btn-primary" disabled={downloading}>
              {downloading ? 'Downloading…' : 'Download CSV'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
